import { combineReducers } from "redux";
import updateAcknowledgementFlagReducer from "./updateAcknowledgementReducer";

const acknowledgementReducer = combineReducers({
    updateAcknowledgementFlag: updateAcknowledgementFlagReducer
});

export default acknowledgementReducer;